import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { AuthService } from './authentication/auth.service';
import { APP_ROUTER } from '../models/app.route';
import { CacheService } from './cashe-service';


@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private idleTimeout: any;
  private idleDuration = 1800000; // miliseconds = 30 Min
  private warningDuration = 31000 // miliseconds = 31 sec

  constructor(private router: Router,
    public authService: AuthService,
    public translate?: TranslateService
  ) {
    this.resetIdleTimer();
    this.monitorUserActivity();
  }

  // Resets the idle timer
  private resetIdleTimer() {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }
    this.idleTimeout = setTimeout(() => this.autoLogout(), this.idleDuration);
  }

  // Monitors user activity (mouse, key press)
  private monitorUserActivity() {
    window.addEventListener('mousemove', () => this.resetIdleTimer());
    window.addEventListener('keydown', () => this.resetIdleTimer());
  }

  // Logs out the user and redirects to the login page
  private autoLogout() {
    if (CacheService.getToken())
      this.logoutNotification();
  }

  timerInterval: number = 0;
  logoutNotification() {

      let timerInterval;
      let isArabic = this.translate.getDefaultLang() == "ar";
      let secondsText = isArabic ? "ثانية" : "seconds";
      Swal.fire({
        icon: 'question',
        iconHtml: '<img src="/assets/images/logout.png" style="width:100%"/>',
        title: this.translate.instant('common.logoutTitleWarning'),
        html: this.translate.instant('common.willRedirectToLogon') + "<b></b> " + secondsText,
        timer: this.warningDuration,
        allowOutsideClick: false,
        timerProgressBar: true,
        confirmButtonColor: "transparent",
        customClass: {
          confirmButton: 'p-0'
        },
        confirmButtonText: `<button type="button" class="btn  btn-load sessionCheckBtn">
        <span class="d-flex align-items-center">
            <span class="spinner-grow flex-shrink-0" role="status">
                <span class="visually-hidden">`+ this.translate.instant('common.stayActive') + `</span>
            </span>
            <span class="flex-grow-1 ms-2">
                `+ this.translate.instant('common.stayActive') + `...
            </span>
        </span>
    </button>`,

        didOpen: () => {
          const timer = Swal.getPopup().querySelector("b");
          timerInterval = setInterval(() => {
            timer.textContent = `${Math.floor(Swal.getTimerLeft() / 1000)}`;
          }, 1000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          this.logout();
        }
        if (result.isConfirmed) {
          Swal.close();
        }
      });

  }

  logout() {
    CacheService.clearCache();
    this.authService.isUserLogin$.next(false);
    this.router.navigate([APP_ROUTER.LOGIN]);
  }

}
